import React, { useEffect, useState } from "react";
import EmailConfigService from "../../services/KangarooServices/EmailConfigService";
import { Badge, Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { formatDate } from "../../Components/Common/FormatDate";
import {
  BiEnvelope,
  BiServer,
  BiKey,
  BiUser,
  BiCalendar,
  BiCheckCircle,
  BiXCircle,
} from "react-icons/bi"; // Boxicons
import EmailConfigForm from "./EmailConfigForm";
import { useNavigate } from "react-router-dom";

const EmailConfig = () => {
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };
  console.log("🚀 ~ EmailConfig ~ data:", data);
  const fetchData = async () => {
    try {
      const response = await EmailConfigService.getList();
      setData(response[0]);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Container fluid>
        <div className="page-content">
          <BreadCrumb title="Email Configuration" pageTitle="User Management" />
          <Row className="mb-3">
            <Col>
              <button
                className="btn btn-success"
                onClick={() => navigate("/test-email")}
              >
                Test Email
              </button>
            </Col>
          </Row>
          <Card className="border-0 shadow-sm rounded-4">
            <CardBody className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0">SMTP Settings</h5>
                <div className="d-flex gap-2 justify-content-center align-content-center align-items-center">
                  <Badge
                    pill
                    color={data?.enableSsl ? "success" : "danger"}
                    className="px-3 py-2"
                  >
                    {data?.enableSsl ? "SSL Protected" : "Insecure"}
                  </Badge>

                  <Button
                    size="sm"
                    color="warning"
                    className="d-flex align-items-center gap-1"
                    onClick={() => toggleModal(data)}
                  >
                    <i className="ri-edit-line"></i>
                  </Button>
                </div>
              </div>

              <dl className="row g-3 mb-0 smtp-info-list">
                <dt className="col-4 text-muted">Sender:</dt>
                <dd className="col-8 fw-medium">{data?.senderEmail || "—"}</dd>

                <dt className="col-4 text-muted">Recipient:</dt>
                <dd className="col-8 fw-medium">
                  {data?.recipientEmail || "—"}
                </dd>

                <dt className="col-4 text-muted">Server:</dt>
                <dd className="col-8 fw-medium font-monospace">
                  {data?.smtpServer || "—"}
                </dd>

                <dt className="col-4 text-muted">Port:</dt>
                <dd className="col-8 fw-medium">{data?.port || "—"}</dd>

                <dt className="col-4 text-muted">Created by:</dt>
                <dd className="col-8 fw-medium">{data?.createdBy || "—"}</dd>

                <dt className="col-4 text-muted">Created:</dt>
                <dd className="col-8">{formatDate(data?.createdAt)}</dd>

                {data?.updatedAt && (
                  <>
                    <dt className="col-4 text-muted">Updated:</dt>
                    <dd className="col-8">{formatDate(data?.updatedAt)}</dd>
                  </>
                )}
              </dl>
            </CardBody>
          </Card>
        </div>
        <EmailConfigForm
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
      </Container>
    </>
  );
};

export default EmailConfig;
